import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getAreas } from 'actions/regions/areas';
import { getAllPorts } from 'actions/regions/ports';

import FilterAreas from './FilterAreas/Component';
import { AreaEditor } from './AreaEditor';

class RegionsDashboards extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.onSelectArea = this.onSelectArea.bind(this);
        this.onSelectAreaById = this.onSelectAreaById.bind(this);
        this.selectParentArea = this.selectParentArea.bind(this);
    }

    onSelectArea(selectedArea) {
        selectedArea.isNew = false;

        this.onSelectAreaById(selectedArea._id);
    }

    onSelectAreaById(areaId) {
        this.setState({
            areaId,
        });
    }

    UNSAFE_componentWillMount() {
        const { getAllPorts, getAreas } = this.props;

        getAllPorts();
        getAreas();
    }

    selectParentArea(searchArea) {
        this.onSelectAreaById(searchArea);
    }

    render() {
        const { areaId, searchArea } = this.state;
        const { ports, areas, router } = this.props;

        return (
            <div id='regions-dashboard' className='page'>
                <div className='container-fluid'>

                    <div className='row'>
                        <div className='col-xs-2'>
                            <FilterAreas
                                router={router}
                                areas={areas}
                                selectedArea={areaId}
                                onSelectArea={this.onSelectArea}
                                // searchArea={searchArea}
                            />
                        </div>

                        <div className="col-xs-10">
                            <AreaEditor
                                ports={ports}
                                areas={areas}
                                areaId={areaId}
                                selectArea={this.onSelectAreaById}
                                router={router}
                                selectParentArea={this.selectParentArea}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ ports, areas, user }) => {
        return {
            ports,
            areas,
            isLogged: user.isLogged,
        };
    },
    dispatch => bindActionCreators({
        getAreas,
        getAllPorts,
    },
    dispatch),
)(RegionsDashboards);



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Page.jsx